// extracted by mini-css-extract-plugin
export default {"stampImage":"HankoSignatureList_stampImage__d0O8u"};